export enum QuestionChooseTenEnum {
  wrongAnswersNumber = 'wrongAnswersNumber',
  correctAnswersNumber = 'correctAnswersNumber'
}
